import axios from "axios";
import { dataUser } from "../utils/dataUser";
import { BASE_API } from "./application.properties";
import { incrementRequest, decrementRequest } from "../utils/requestTracker";

export const API = axios.create({
  baseURL: BASE_API,
});

API.interceptors.request.use((config) => {
  const token = dataUser.getToken();

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  if (!config._tracked) {
    config._tracked = true;
    incrementRequest();
  }

  return config;
});

API.interceptors.response.use(
  (response) => {
    if (response.config && response.config._tracked) {
      decrementRequest();
    }
    return response;
  },
  (error) => {
    if (error && error.config && error.config._tracked) {
      decrementRequest();
    }
    return Promise.reject(error);
  }
);
